export default __webpack_public_path__ + "static/media/data-insufficient.fa8c0560.svg";